<template>
    <div class="sign_list">
        <div class="task_title">
            做任务
<!--            赚学分-->
        </div>
        <div class="task_list">
            <div class="task_item" v-for="(item , index) in dataList" :key="index">
                <div class="flex_left" style="display: flex;">
                    <div class="task_name">
                        {{item.taskTitle}}
                        <span v-if="item.taskFulfillCount !== 1">
                            ({{item.taskCurrentCount}}/{{item.taskFulfillCount}})
                        </span>
<!--                        <span class="redfont">-->
<!--                            +{{item.awardList[0].value}}学分-->
<!--                        </span>-->
                    </div>
                    <div class="task_state">{{item.remark}}</div>
                </div>
                <div v-if="item.taskCompletionStatus === 4" class="flex_right">
                    <div class="btn_task" style="opacity:.6;">
                        已领取奖励
                    </div>
                </div>
                <div v-else class="flex_right">
                    <div v-if="item.taskCode === '1'" class="btn_task">
                        <router-link class="white" to="/learn">去点赞</router-link>
                    </div>
                    <div v-if="item.taskCode === '2'" class="btn_task">
                        <router-link class="white" to="/me/meComp/learnListMore">去评论</router-link>
                    </div>
                    <div v-if="item.taskCode === '3'" class="btn_task">
                        <a class="white" :href="externalApp.oldShixun.baseUrl + 'html/quan/mengQuan.html'">发布视频</a>
                    </div>
                    <div v-if="item.taskCode === '4'" class="btn_task">
                        发布动态
                    </div>
                    <div v-if="item.taskCode === '5'" class="btn_task">
                        去关注
                    </div>
                    <div v-if="item.taskCode === '6'" class="btn_task">
                        <span v-if="!signState.isSignIn" @click="toSignIn">
                            马上签到
                        </span>
                        <span :style="{'opacity': (signState.isSignIn== true ? '.6':'1')}" v-else>
                            已签到
                        </span>
                    </div>
                    <div @click="toTransmit" v-if="item.taskCode === '7'" class="btn_task" style="opacity: .6">
                        去转发
                    </div>
                    <div @click="toTransmit" v-if="item.taskCode === '8'" class="btn_task">
                        去分享
                    </div>
                    <div v-if="item.taskCode === '9'" :style="{'opacity': (signState.isSignIn== true ? '.6':'1')}"
                         class="btn_task">
                       <span v-if="!signState.isSignIn" @click="toSignIn">
                            马上签到
                        </span>
                        <span v-else>
                            已签到
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import externalApp from '@data/externalApp';

// platformApi
import requestManager from '@comp/platformApi/requestManager'

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig: {
        list: {
            url: '/portal/v4/user/center/task/list',
            dataPath: 'data',
            // totalPath : 'data.total',
            // totalPagePath : 'data.pages'
        }
    }
};

export default {
    name: "signTask",
    extends : shixunPagePart,
    props: ['paramValue'],
    watch: {
        paramValue(val, oldVal) {//普通的watch监听
            this.reloadDataList();
            this.getSignState();
            //  this.getSignReturn();
        },
    },
    data() {
        return {
            enableDataList: true,
            autoLoadDataList: true,
            scrollToLoadNextPage: false,
            apiConfig: config.apiConfig,
            signState: {},
            externalApp : externalApp
        }
    },


    methods: {
        getSignState() {

            requestManager.request({
                url: '/portal/v4/user/center/task/getSignInfo'
            }, (error, result) => {

                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }
                this.signState = result.data;
            });
        },

        getSignReturn() {

            requestManager.request({
                method: 'post',
                url: '/portal/v4/user/center/task/signIn',
            }, (error, result) => {

                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                if (result.data && result.data.result === true) {
                    appHelper.showHint('今日已签到成功');
                    this.reloadDataList();
                    this.getSignState();
                    this.$emit('taskChange', 'true');

                } else {
                    appHelper.showHint('签到失败')
                }

            });

        },

        toSignIn() {
            if (this.signState.isSignIn === false || this.signState.isSignIn === null) {
                this.getSignReturn();
            } else {
                appHelper.showHint('签到失败')
            }
        },

        toTransmit() {
            // appHelper.showHint('点击右上角转发哦~')
        }
    },
    mounted() {
        this.getSignState();
    }
}
</script>
<style lang="scss" scoped>


.redfont {

    font-size: 14px;
    font-weight: 500;
    color: #FF3A3A;

}

.sign_list {

    width: 94%;
    margin: 0 auto;
    padding: 12px;
    // height: 343px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 15px rgba(153, 155, 158, 0.2);

    border-radius: 14px;
    position: relative;
    box-sizing: border-box;


}

.task_title {
    padding-bottom: 6px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;

}

.task_item {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
}

.flex_left {
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;
    line-height: 37px;
    .task_name {

        font-size: 14px;
        font-weight: 400;
        color: #000000;

    }
    .task_state {

        font-size: 12px;
        font-weight: 400;
        color: #999999;

    }
}

.flex_right {
    height: 37px;
    display: flex;
    align-items: center;

    .btn_task {
        width: 64px;
        height: 24px;
        background: linear-gradient(145deg, #FF681A 0%, #FFA631 100%);
        border-radius: 12px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;

        // padding: 0 12px;
    }
}

</style>
